var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text",staticStyle:{"width":"100%","height":"100%","margin-top":"60%","text-align":"center","font-size":"15px"}},[_vm._v(" 如支付已完成，请关闭此页面，否则请重新发起支付 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }